import { render, staticRenderFns } from "./guardianDetail.vue?vue&type=template&id=08e95c8a&scoped=true"
import script from "./guardianDetail.vue?vue&type=script&lang=js"
export * from "./guardianDetail.vue?vue&type=script&lang=js"
import style0 from "./guardianDetail.vue?vue&type=style&index=0&id=08e95c8a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08e95c8a",
  null
  
)

export default component.exports